import type { DeviceConfiguration } from '../../../data/configuration/types';

import { DeviceConfigurationForcedUpdateURL } from './types';

export function processForceUpgradeLinks(
  forcedUpdateUrls: DeviceConfigurationForcedUpdateURL,
): NonNullable<DeviceConfiguration['forceUpgradeLinks']> {
  const links: Record<string, string> = {};

  for (let i = 0; i < forcedUpdateUrls.length; i++) {
    const link = forcedUpdateUrls[i];

    const [[key, value]] = Object.entries(link);

    links[key] = value;
  }

  return links;
}
